import { CATEGORY_JOBS_STORAGE_KEY, CATEGORY_JOBS_UPDATED_EVENT } from '@/constants';

export const loadCategoryJobsFromStorage = (): {
    jobId: string;
    date: string;
}[] => {
    const jobs = localStorage.getItem(CATEGORY_JOBS_STORAGE_KEY);
    return jobs ? JSON.parse(jobs) : [];
};

export const saveCategoryJobsToStorage = (jobs: { jobId: string; date: string }[]) => {
    localStorage.setItem(CATEGORY_JOBS_STORAGE_KEY, JSON.stringify(jobs));
    window.dispatchEvent(new Event(CATEGORY_JOBS_UPDATED_EVENT));
};

export const addCategoryJobToStorage = (jobId: string) => {
    const jobs = loadCategoryJobsFromStorage();
    jobs.push({ jobId, date: new Date().toISOString() });
    saveCategoryJobsToStorage(jobs);
};

export const clearOldCategoryJobsFromStorage = (days: number) => {
    const DAYS_MS = days * 24 * 60 * 60 * 1000;
    const now = new Date().getTime();

    const jobs = loadCategoryJobsFromStorage().filter(job => now - new Date(job.date).getTime() <= DAYS_MS);

    saveCategoryJobsToStorage(jobs);
};
